/**
 * TypingIndicator - "X is typing..." with animated dots.
 */

import React from 'react';
import type { TypingUser } from '../../types/chat';

interface TypingIndicatorProps {
  users: TypingUser[];
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ users }) => {
  if (users.length === 0) return null;

  const names = users.map(u => u.username).join(', ');
  const verb = users.length === 1 ? 'is' : 'are';

  return (
    <div className="px-4 py-1.5 text-xs text-gray-500 flex items-center gap-1">
      <span className="inline-flex gap-0.5">
        <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
        <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
        <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
      </span>
      <span>{names} {verb} typing</span>
    </div>
  );
};

export default TypingIndicator;
